module.exports = __webpack_public_path__ + "img/rank_staff_sergeant.38cdd221.svg";